import * as React from "react";
import { Alert, Modal } from "antd";
import { LoaderSmall } from "../../../components/layout/loader/small";
import { LogsBrowserService } from "./logsBrowser";
import { useAppSelector } from "../../../store/hooks";
import { KindSelect } from "../../../components/antd/kindselect/KindSelect";
import { parseLink } from "../../../utils/linkParser/linkParser";

interface Props {
  lbs: LogsBrowserService;
}
export const LogsBrowserCloudAccountModal: React.FC<Props> = ({ lbs }) => {
  const bss = useAppSelector((state) => state.browserService);

  const [cavalue, setCavalue] = React.useState("");

  return (
    <Modal
      title={"Select Cloudaccount"}
      width={500}
      open={lbs.page === "cloudaccount"}
      maskClosable={false}
      onCancel={() => {
        lbs.setCloudAccountName("");
        lbs.setPage("none");
      }}
      onOk={() => lbs.prepare()}
      okText={`Next`}
      okButtonProps={{
        loading: lbs.isCheckingReach,
        disabled: !lbs.cloudAccountName || !bss.canReach || lbs.isCheckingReach,
      }}
    >
      {lbs.isPreparing ? (
        <div className="flex items-center justify-center flex-col" style={{ height: 300 }}>
          <LoaderSmall />
          <div className="mt-2">Please wait. Loading items.</div>
        </div>
      ) : null}
      {!lbs.isPreparing ? (
        <>
          <KindSelect
            className="mb-4"
            kind={"cloudaccount"}
            optionValue="name"
            value={cavalue}
            onChange={setCavalue}
            onStateChange={(state) => {
              const name = parseLink(state.link, { useInputCtx: true }).name;
              lbs.setCloudAccountName(name);
            }}
            queries={[{ property: "provider", value: "aws" }]}
          />
          {lbs.prepareError ? (
            <Alert type={"error"} message={"This cloud account cannot reach the provider. Select another one."} />
          ) : null}
          {bss.reachError ? <Alert type={"error"} message={bss.reachError} /> : null}
        </>
      ) : null}
    </Modal>
  );
};
